import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { ApplicationsService } from 'app/services/applications.service';
import { Alert } from 'app/shared/alerts/simple-message/simple-message.component';
import { AssociationHelper } from 'app/storage/association.storage';
import { SessionStorage } from 'app/storage/session.storage';
import { lastValueFrom } from 'rxjs';
import { SopStorage } from 'app/storage/sop.storage';

const SERVICE_TYPES = ['service1', 'service2', 'service3']

@Component({
  selector: 'survey-dashboard',
  templateUrl: './survey-dashboard.component.html',
  styleUrls: ['./survey-dashboard.component.scss']
})
export class SurveyDashboardComponent implements OnInit {

  MEETING: number = 0
  project: any = {}
  epe: any = {}

  showAlert: boolean = false
  alertMessage: string = ''
  alertType: Alert = Alert.SUCCESS

  constructor(
    private router: Router,
    private service: AssociationsService,
    private helper: AssociationHelper,
    public auth: SessionStorage,
    private cache: SopStorage,
    private applicationsService: ApplicationsService,
  ) {}

  async ngOnInit(){
    if (!this.helper.getSelectedEpe()) {
      this.router.navigate(['/associations'])
      return
    }

    const project_id = this.helper.getSelectedProject()
    const epe_id = this.helper.getSelectedEpe()

    let projects = this.cache.getProjects()
    let epes = this.cache.getEpes()

    if (!projects) {
      const apps = await lastValueFrom(this.applicationsService.getAll({ include_user: true }))
      projects = apps
        .filter((a: any) => SERVICE_TYPES.includes(a.application_type))
        .map((app: any) => ({
          ...(app.form_data || {}),
          ...(app.user_info || {}),
          ...app,
          id: app.user_id ?? app.id,
          application_id: app._id?.['$oid'] ?? app._id,
          sop_status: app.status,
        }))
      this.cache.setProjects(projects)
    }

    if (!epes) {
      const apps = await lastValueFrom(this.applicationsService.getAll({ type: 'epe', include_user: true }))
      epes = apps.map((app: any) => ({
        ...(app.form_data || {}),
        ...(app.user_info || {}),
        ...app,
        id: app.user_id ?? app.id,
        application_id: app._id?.['$oid'] ?? app._id,
        sop_status: app.status,
      }))
      this.cache.setEpes(epes)
    }

    this.project = projects.find(p => p.application_id == project_id) || {}
    this.epe = epes.find(e => e.application_id == epe_id) || {}

    this.MEETING = (await lastValueFrom(this.service.getFormStatus(project_id, epe_id))).meeting
  }

}
